import { AgentService } from './../../../services/agent.service';
import { Utils } from './../../../utils';
import { ImageComponent } from './../../image/image.component';
import { CommandeService } from './../../../services/commande.service';
import { StoreService } from './../../../services/store.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelectItem, Message, ConfirmationService } from 'primeng/primeng';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-validation',
  templateUrl: './validation.component.html',
  styleUrls: ['./validation.component.css']
})
export class ValidationComponent implements OnInit {
  titre = 'Validation commande';
  commande: any;
  displayCategorie: boolean;
  displayNafama: boolean;
  typeCommande: string;
  colorFieldset = 'primary';
  colorPanel = 'primary';
  profil = 'adv';
  itemPaiements: any[] = [];
  itemDepots: any[] = [];
  listBanque: SelectItem[] = [];
  listModeReglement: SelectItem[] = [];
  listProduits: SelectItem[] = [];
  fr = {
    firstDayOfWeek: 0,
    monthNames: [
      'Janvier', 'Février', 'Mars',
      'Avril', 'Mai', 'Juin',
      'Juillet', 'Août', 'Septembre',
      'Octobre', 'Novembre', 'Décembre'
    ],
    monthNamesShort: ['Janv.', 'Févr.', 'Mars', 'Avr.', 'Mai', 'Juin', 'Juil.', 'Août', 'Sept.', 'Oct.', 'Nov.', 'Déc.'],
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim.', 'Lun.', 'Mar.', 'Mer.', 'Jeu.', 'Ven.', 'Sam.'],
    dayNamesMin: ['D', 'L', 'M', 'M', 'J', 'V', 'S']
  };
  today: any = new Date();
  commandeForm: FormGroup;
  msgs: Message[] = [];
  uploadedFiles: any[] = [];
  categoriePiece: string;
  readOnlyOracle: any;
  readOnlyOracleCompta: any;
  referenceOracle: string;
  zoneLivraison: string;
  commentaire: string;
  produitOracle: any = [];
  listProduitOracle: any = [];
  listZone: SelectItem[] = [];
  sommeTotalProduit = 0;
  sommeTotalProduitOracle = 0;
  displaychargement = false;
  displayDialogDepot : boolean;
  idTransactionDepot : string;
  idItem : any;
  @ViewChild(ImageComponent, { static: false }) image: ImageComponent;
  images = [];
  constructor(
    private activatedRoute: ActivatedRoute,
    private store: StoreService,
    private formBuilder: FormBuilder,
    private commandeService: CommandeService,
    private route: Router,
    public authService: AuthService,
    private agentService: AgentService,
    private confirmationService: ConfirmationService
  ) { }

  async ngOnInit() {
    console.log('commandeService.disableValidButton: ', this.commandeService.canValidButton);
    /*
    if (this.store.tmp.commande) {
      this.commande = this.store.tmp.commande;
      this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => this.commande.typeCommande.toLowerCase() === 'produits' ? e.montant * e.quantite : e.montant).reduce((t, e) => t + e);
      console.log('this.commande.piecesJointes: ', this.image, this.commande.piecesJointes);
      // this.image.clearFileNames();
      // this.image.addFileNames(this.printFileName(this.commande.piecesJointes));
      this.images = this.printFileName(this.commande.piecesJointes).split(';').filter(e => e.trim()).map(e => Utils.newGalleryImage(e));
    } else {
      this.activatedRoute.queryParamMap.subscribe(async (params) => {
        const id = params.get('id');
        if (!id) {
          return window.history.back();
        }
        console.log('id: ', id);
        await this.loadCommande(id);
      });
    }
    */

    this.activatedRoute.queryParamMap.subscribe(async (params) => {
      const id = params.get('id');
      if (!id) {
        return window.history.back();
      }
      console.log('id: ', id);
      await this.loadCommande(id);
    });

    await this.getListZone();
    
  }

  private async loadCommande(id: any) {
    try {
      this.commande = await this.commandeService.commande(id).toPromise();
      console.log('commande: ************' , this.commande);
      this.sommeTotalProduit = this.commande.listProduit.length === 0 ? 0 : this.commande.listProduit.map(e => this.commande.typeCommande.toLowerCase() === 'produits' ? e.montant * e.quantite : e.montant).reduce((t, e) => t + e);
      console.log('this.commande.piecesJointes: ', this.commande.piecesJointes);
      // this.image.clearFileNames();
      // this.image.addFileNames(this.printFileName(this.commande.piecesJointes));
      this.images = this.printFileName(this.commande.piecesJointes).split(';').map(e => Utils.newGalleryImage(e));
      console.log('image:', this.images);
    } catch (error) {

    } finally {
    }
  }


  retour() {
    this.displayCategorie = true;
    this.displayNafama = false;
  }

  async loadOracle() {
    this.displaychargement = true;
    try {
      this.produitOracle = await this.commandeService.getOracleData(this.referenceOracle).toPromise();
      console.log('oracles**********: ', this.produitOracle);
      this.sommeTotalProduitOracle = this.listProduitOracle.length === 0 ? 0 : this.listProduitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }


  async chargerOracle(role: string) {
    let reference: any;
    if (role === 'ADV') {
      reference = this.commande.referenceOracle;
    } else {
      reference = this.commande.referenceOracleCompta;
    }
    this.displaychargement = true;
    try {
      this.listProduitOracle = await this.commandeService.getOracleData(reference).toPromise();
      console.log('oracles**********: ', this.listProduitOracle);
      this.sommeTotalProduitOracle = this.listProduitOracle.length === 0 ? 0 : this.listProduitOracle.map(e => e.fulfield_quantity * e.unit_selling_pricing).reduce((t, e) => t + e);
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }

  }

  async validerCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    /*
    if (this.authService.currentUser.role === 'ADV' && (this.referenceOracle == null || this.referenceOracle === undefined || this.referenceOracle === '')) {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'La reference est obligatoire !!!' });
      return;
    }
    */
    this.validerCommandeWithConfirmation('Voulez-vous valider cette commande ?');
  }


  validerCommandeWithConfirmation(message: any) {
    this.confirmationService.confirm({
      message: message,
      accept: async () => {
        this.displaychargement = true;
        try {
          await this.commandeService.next(
            this.commande.id,
            {
              pieces: this.uploadedFiles,
              commentaire: this.commentaire,
              referenceOracle: this.referenceOracle,
              zone: this.zoneLivraison
            })
            .toPromise();
          this.msgs = [];
          this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
          setTimeout(()=>{
            console.log('waiting');
          this.route.navigateByUrl('/root/list-commande');
          }, 100);
        } catch (error) {

        } finally {
          this.displaychargement = false;
        }
      }
    });
  }

  rejetCommandeWithConfirmation(message: any) {
    this.confirmationService.confirm({
      message: message,
      accept: async () => {
        this.displaychargement = true;
        try {
          await this.commandeService.previous(this.commande.id,
            { pieces: this.uploadedFiles, commentaire: this.commentaire, referenceOracle: this.referenceOracle }
          ).toPromise();
          this.msgs = [];
          this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
          setTimeout(()=>{
            console.log('waiting');
            this.route.navigateByUrl('/root/list-commande');
          }, 100);
        } catch (error) {

        } finally {
          this.displaychargement = false;
        }
      }
    });
  }

  async rejeterCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    this.rejetCommandeWithConfirmation('Voulez-vous rejeter cette commande ?');
  }

  async UpdateCommande() {
    if (this.commentaire == null || this.commentaire === undefined || this.commentaire === '') {
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Le commentaire est obligatoire !!!' });
      return;
    }
    this.displaychargement = true;
    try {
      await this.commandeService.update(
        this.commande.id,
        {
          commentaire: this.commentaire,
        })
        .toPromise();
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
      this.route.navigateByUrl('/root/list-commande');
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
  }

  async getListZone() {
    console.log('getListZone: ', this.listZone);
    this.listZone = [
      { label: 'ZONE...', value: null },
      ...(await this.agentService.findAllZone().toPromise() as any).map(element => {
        return {
          label: element.nom, value: element.nom
        };
      })];
    console.log('listZone: ', this.listZone);
  }

  initForm() {
    this.commandeForm = this.formBuilder.group({
      referenceOracle: [this.commande && this.commande.referenceOracle, [Validators.required]],
    });
  }
  actualiser() {
    this.ngOnInit();
  }

  exportCharges() {
  }

  printFileName(names: string): string {
    const images = names.split(';').filter(e => e).map(a => a + '.jpg').join(';');
    console.log('images::', images);
    return images;
  }

  async detectFiles0(event) {
    console.log('files: ', event.target.files);
    const files = [];
    for (let i = 0; i < event.target.files.length; i++) {
      files.push(event.target.files[i]);
    }
    await Promise.all(files.map(async file => {
      try {
        const filesNames = (await this.commandeService.sendToOpenStack(file, files.indexOf(file)).toPromise() as any);
        console.log('filesNames: ', filesNames);
        filesNames.forEach(async (element: any) => {
          this.uploadedFiles.push({
            nom: element,
            categorie: this.categoriePiece,
            agent: this.authService.currentUser.login,
            profil: this.authService.currentUser.role
          });
        });
      } catch (error) {
      }
    }));
    console.log('uploadedFiles: ', this.uploadedFiles);
  }

  editElement(cat) {
    this.displayDialogDepot = true;
    this.idTransactionDepot = "";
    this.idItem = cat.id;
}

async save() {
    // Appeler service de save
    if(this.idTransactionDepot === '' || this.idTransactionDepot === null || this.idTransactionDepot=== undefined){
      this.msgs.push({ severity: 'error', summary: 'Confirmation', detail: 'Merci de renseigner l\' ID TRANSACATION' });
      return;
    }
    this.displaychargement = true;
    try {
      await this.commandeService.saveDetail(this.idItem, this.idTransactionDepot)
        .toPromise();
      this.msgs = [];
      this.msgs.push({ severity: 'info', summary: 'Confirmation', detail: 'Traitement effectué avec succès' });
      this.displayDialogDepot = false;
      this.actualiser();
    } catch (error) {

    } finally {
      this.displaychargement = false;
    }
}
}
